module.exports = __webpack_public_path__ + "static/keoghtoms_ointment-4562c528bdd47f91dfa781e312843faf.jpeg";